import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Suspense } from 'react';

import { Text } from '@/components/Typography/Text';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { useAttendanceLink } from './-hooks';

export const Route = createFileRoute(
  '/_staff/time-and-attendance/_layout/attendance-links/',
)({
  component: AttendanceLinkPage,
});

function AttendanceLinkPage() {
  return (
    <Suspense fallback={<LoadingState />}>
      <AttendanceLinkRedirectPage />
    </Suspense>
  );
}

function LoadingState() {
  return (
    <div className="p-6 flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );
}

/**
 * This component fetches the attendance link data and redirects to the placeId route
 */
function AttendanceLinkRedirectPage() {
  const navigate = useNavigate();
  const { data } = useAttendanceLink();
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.timeAndAttendance.attendanceLinks.redirect',
  });

  const placeId = data.placePager?.current?.id;

  if (!placeId) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded my-4">
          <Text>{t('noLocation')}</Text>
        </div>
      </div>
    );
  }

  navigate({
    to: '/time-and-attendance/attendance-links/$placeId',
    params: { placeId },
    replace: true,
  });

  return (
    <div className="p-6 flex justify-center items-center h-64">
      <Text>{t('redirecting')}</Text>
    </div>
  );
}
